/** @file instanceState: the host-facing snapshot of an instance after its last update. */
import { facingStepsOf } from '@zilo/pose3d-pose/facing/facingStepsOf';
import { clipFrame } from '@zilo/pose3d-pose/time/clipFrame';
import { clipEnded } from '@zilo/pose3d-runtime-babylon/clip/clipEnded';
import type { InstanceCore, PuppetInstanceState } from '@zilo/pose3d-runtime-babylon/instance/puppetInstanceTypes';

/** The clip fields of the state (empty clip, frame 0 before the first `play`). */
function clipPart(core: InstanceCore): Pick<PuppetInstanceState, 'clip' | 'category' | 'time' | 'frame' | 'ended' | 'paused'> {
  const c = core.clock;
  if (c === null) return { clip: '', category: '', time: 0, frame: 0, ended: false, paused: false };
  const frame = clipFrame(c.clip, c.time, { frame: 0, wraps: 0, elapsed: 0, ticks: 0 }).frame;
  return { clip: c.clip.name, category: c.clip.category, time: c.time, frame, ended: clipEnded(c.clip, c.time), paused: c.paused };
}

/** Clip name, category, time, clip frame (pose `clipFrame`), ended, facing, steps in force, group and the last frame. */
export function instanceState(core: InstanceCore): PuppetInstanceState {
  return {
    ...clipPart(core), facingDeg: core.facing, headingDeg: core.heading,
    steps: core.steps ?? facingStepsOf(core.puppet, core.clock?.clip ?? null), weaponGroup: core.weaponGroup, count: core.last.count,
    picks: core.last.picks, list: core.last.list, pose: core.last.pose, lastEvents: core.lastEvents,
  };
}
